import { ModuleDeletionBlocked } from '@/modules/types/elearning/moduleDeletionBlocked';

// Narrow the RTK Query error to the 409 module-deletion-blocked shape.
// Validates `courses` is an array so downstream `.slice`/`.map` is safe even if
// the body is malformed — we don't blindly trust the error payload.
export const isModuleDeletionBlocked = (
  err: unknown,
): err is { status: 409; data: ModuleDeletionBlocked } => {
  if (typeof err !== 'object' || err === null) {
    return false;
  }
  const { status, data } = err as { status?: number; data?: unknown };
  if (status !== 409 || typeof data !== 'object' || data === null) {
    return false;
  }
  const body = data as { blocked?: unknown; courses?: unknown };
  return body.blocked === true && Array.isArray(body.courses);
};